module.exports = __webpack_public_path__ + "static/media/logo-inland-services.7474741d.svg";